import React from "react";
import { Redirect } from "react-router-dom";

const Home = () => <Redirect to="/4/0" />;

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js